import { DateTime } from "luxon";
import { Currency } from "..";
/**
 * Locale util leverages Intl to format dates, numbers, etc. based on locale.
 */
var LocaleUtil = /** @class */ (function () {
    function LocaleUtil() {
    }
    /**
     * Returns formatted date as string using the locale's DateFormatString or
     * a token pattern string, e.g., for default date formats.
     * @param {string} date date in ISO format
     * @param {string} locale should be of type Locale but we accept a string to support
     * locale overrides when applicable.
     * @param {string} dateFormatString used to determine the date pattern, should
     * follow the DateFormatString type. Parameter type is string since that type
     * is returned from the DefaultDateFormatMap.
     */
    LocaleUtil.getDateString = function (date, locale, dateFormatString) {
        var localeOverride = LocaleUtil.localeOverrideMap.get(locale);
        if (localeOverride) {
            locale = localeOverride;
        }
        // return formatted date based on locale and date pattern
        return DateTime.fromISO(date)
            .setLocale(locale)
            .toFormat(dateFormatString);
    };
    /**
     * Returns formatted datetime as string using the locale's DateTimeFormatString or
     * a token pattern string, e.g., for default date formats.
     * @param {string} date date in ISO format
     * @param {string} locale should be of type Locale but we accept a string to support
     * locale overrides when applicable.
     * @param {string} dateTimeFormatString used to determine the date pattern, should
     * follow the DateFormatString type. Parameter type is string since that type
     * is returned from the DefaultDateTimeFormatMap.
     * @param {string} timezone name of the user's timezone e.g. "US/Pacific"
     */
    LocaleUtil.getDateTimeString = function (date, locale, dateTimeFormatString, timezone) {
        var localeOverride = LocaleUtil.localeOverrideMap.get(String(locale));
        if (localeOverride) {
            locale = localeOverride;
        }
        // return formatted date based on locale and date pattern
        return DateTime.fromISO(date)
            .setLocale(locale)
            .setZone(timezone)
            .toFormat(dateTimeFormatString);
    };
    /**
     * TODO: product to decide between numbers vs Arabic numerals for Arabic formatting
     *   ensure 'en-##' entries are added to Locale.ts if this method is desired.
     * Smartsheet currently supports a handful of languages, this method substitutes
     * some locale code languages for English since Intl support for languages doesn't
     * always match up with Smartsheet's expected behavior. This map should never be exposed
     * publicly since we shouldn't allow consumer's to deviate from the defined locales.
     * e.g., names of months remain as numbers when "ja" language code is used.
     */
    LocaleUtil.localeOverrideMap = new Map([
        ["ar-AE", "en-AE"],
        ["ar-BH", "en-BH"],
        ["ar-EG", "en-EG"],
        ["ar-IQ", "en-IQ"],
        ["ar-JO", "en-JO"],
        ["ar-KW", "en-KW"],
        ["ar-LB", "en-LB"],
        ["ar-OM", "en-OM"],
        ["ar-QA", "en-QA"],
        ["ar-SA", "en-SA"],
        ["ar-SD", "en-SD"],
        ["ar-SY", "en-SY"],
        ["ar-YE", "en-YE"],
        ["ja-JP", "en-JP"] // Japanese to English - Japan
    ]);
    LocaleUtil.currencyStringMap = new Map([
        [Currency.NONE, "NONE"],
        [Currency.ARS, "ARS"],
        [Currency.AUD, "AUD"],
        [Currency.BRL, "BRL"],
        [Currency.CAD, "CAD"],
        [Currency.CHF, "CHF"],
        [Currency.CLP, "CLP"],
        [Currency.CNY, "CNY"],
        [Currency.CZK, "CZK"],
        [Currency.DKK, "DKK"],
        [Currency.EUR, "EUR"],
        [Currency.GBP, "GBP"],
        [Currency.HKD, "HKD"],
        [Currency.ILS, "ILS"],
        [Currency.INR, "INR"],
        [Currency.JPY, "JPY"],
        [Currency.KRW, "KRW"],
        [Currency.MXN, "MXN"],
        [Currency.MYR, "MYR"],
        [Currency.NOK, "NOK"],
        [Currency.NZD, "NZD"],
        [Currency.PHP, "PHP"],
        [Currency.PLN, "PLN"],
        [Currency.RON, "RON"],
        [Currency.RUB, "RUB"],
        [Currency.SEK, "SEK"],
        [Currency.SGD, "SGD"],
        [Currency.TWD, "TWD"],
        [Currency.USD, "USD"],
        [Currency.VND, "VND"],
        [Currency.YTL, "YTL"],
        [Currency.ZAR, "ZAR"]
    ]);
    return LocaleUtil;
}());
export { LocaleUtil };
//# sourceMappingURL=LocaleUtil.js.map